import { STATIC_URL } from 'constants/data'

const IMG_EXT = ['png', 'jpeg', 'jpg', 'webp']

const iconsCommonData = {
  width: 36,
  height: 46,
  unoptimized: true,
  alt: 'Прикрепленный материал',
}

const iconsData = {
  xlsx: {
    src: `${STATIC_URL}/clinical-case/icon-xlsx.svg`,
    ...iconsCommonData,
  },
  pptx: {
    src: `${STATIC_URL}/clinical-case/icon-pptx.svg`,
    ...iconsCommonData,
  },
  ppt: {
    src: `${STATIC_URL}/clinical-case/icon-ppt.svg`,
    ...iconsCommonData,
  },
  jpeg: {
    src: `${STATIC_URL}/clinical-case/icon-jpeg.svg`,
    ...iconsCommonData,
  },
  jpg: {
    src: `${STATIC_URL}/clinical-case/icon-jpeg.svg`,
    ...iconsCommonData,
  },
  png: {
    src: `${STATIC_URL}/clinical-case/icon-png.svg`,
    ...iconsCommonData,
  },
  docx: {
    src: `${STATIC_URL}/clinical-case/icon-docx.svg`,
    ...iconsCommonData,
  },
  pdf: {
    src: `${STATIC_URL}/clinical-case/icon-pdf.svg`,
    ...iconsCommonData,
  },
  doc: {
    src: `${STATIC_URL}/clinical-case/icon-doc.svg`,
    ...iconsCommonData,
  },
}

export { iconsData, IMG_EXT }
